import { Outlet } from "react-router-dom";
import { Sidebar } from "../components/Sidebar";

export function DesktopLayout() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "240px minmax(0, 1fr)",
        height: "100dvh",
        background: "var(--ant-color-bg-layout)",
      }}
    >
      <Sidebar />
      <main style={{ overflow: "auto", minWidth: 0 }}>
        <Outlet />
      </main>
    </div>
  );
}
